var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.page)?_c('div',[(_vm.page.type === _vm.PageType.Home)?_c('HomeHeader'):_c('PageHeader',{attrs:{"title":_vm.transl8(_vm.page.name)}}),_vm._v(" "),_c('ContentBlockList',{attrs:{"blocks":_vm.contentBlocks}}),_vm._v(" "),(_vm.page.type === _vm.PageType.Home)?_c('EventDetails'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }